import { render, staticRenderFns } from "./WechatLogin.vue?vue&type=template&id=3ca4c985&scoped=true&"
import script from "./WechatLogin.vue?vue&type=script&lang=js&"
export * from "./WechatLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca4c985",
  null
  
)

export default component.exports